module.exports = __webpack_public_path__ + "ptc_nakagawa_T2.0830333d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_T2.jpg
// module id = fy1a
// module chunks = 0